import { faQuestionCircle } from '@fortawesome/pro-light-svg-icons';
import ConfirmModal from 'components/modals/ConfirmModal';
import { LoggedUserContext } from 'context/logged-user/loggeduser.context';
import { useI18n } from 'hooks/useI18n';
import { useContext } from 'react';
import { OfferAlertConfirmSaveModalProps } from './OfferAlertConfirmSaveModal.types';

export const OfferAlertConfirmSaveModal: React.FC<
  OfferAlertConfirmSaveModalProps
> = ({ isOpen, close, onConfirm, onSignupClick }) => {
  const { t } = useI18n('job-offer-list');
  const { user } = useContext(LoggedUserContext);

  return (
    <ConfirmModal
      isOpen={isOpen}
      close={close}
      action={async () => {
        if (user) {
          onConfirm();
        } else {
          onSignupClick();
        }
      }}
      icon={faQuestionCircle}
      iconVariant="info"
      cancelText={t('job-offer-list.alert-confirm-save-modal.action-cancel')}
      confirmText={
        user
          ? t('job-offer-list.alert-confirm-save-modal.action-confirm')
          : t(
              'job-offer-list.alert-confirm-save-modal.action-confirm-not_logged'
            )
      }
      title={t('job-offer-list.alert-confirm-save-modal.title')}
      text={
        user
          ? t('job-offer-list.alert-confirm-save-modal.text')
          : t('job-offer-list.alert-confirm-save-modal.text-not_logged')
      }
    />
  );
};

export default OfferAlertConfirmSaveModal;
